// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1gXo0","signatureBlock":"Footer_signatureBlock__8Po_D","signature":"Footer_signature__3iat0"};